import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "el-text__primary" }, " Page Not Found ", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Back ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_result = _resolveComponent("el-result")!
  const _component_DashboardLayout = _resolveComponent("DashboardLayout")!

  return (_openBlock(), _createBlock(_component_DashboardLayout, null, {
    header: _withCtx(() => [
      _createVNode(_component_el_row, {
        type: "flex",
        justify: "space-between",
        align: "middle"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 0 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_el_result, {
        title: "404",
        "sub-title": "The resource requested could not be found!"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_el_image, {
            src: require('@/assets/images/errors/page-not-found.svg')
          }, null, 8, ["src"])
        ]),
        extra: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "medium",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/dashboards')))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}